(function () {
  var wrap = document.querySelector("[data-ts-trade-link]");
  if (!wrap) return;
  var anchor = wrap.querySelector("[data-ts-trade-anchor]");
  var base = wrap.getAttribute("data-ts-trade-base");
  var selection = document.querySelector("[data-variant-selection]");
  if (!anchor || !base) return;

  function variantId() {
    var value = selection && selection.getAttribute("variant");
    return value && /^\d+$/.test(value) ? value : "";
  }

  function quantity() {
    var input = document.querySelector("[data-product-form-regular] [data-quantity-input]");
    var n = input ? parseInt(input.value, 10) : 1;
    return isFinite(n) && n > 1 ? n : 0;
  }

  function sync() {
    var href = base;
    var variant = variantId();
    var qty = quantity();
    if (variant) href += "&variant=" + variant;
    if (qty) href += "&qty=" + qty;
    anchor.setAttribute("href", href);
  }

  if (selection && window.MutationObserver) {
    new MutationObserver(sync).observe(selection, { attributes: true, attributeFilter: ["variant"] });
  }
  document.addEventListener("input", sync);
  document.addEventListener("change", sync);
  document.addEventListener("click", function (event) {
    if (event.target.closest && event.target.closest(".quantity-selector")) setTimeout(sync, 0);
  });
  sync();
})();
